// Восстановлена по строке и дальнейшей обработке
export function parsePassportInfo(input) {
  if (!input || typeof input !== 'string') {
    return null;
  }

  const result = {
    series: '',
    number: '',
    when: '',
    whom: ''
  };

  // Удаляем лишние пробелы
  const normalized = input.replace(/\s+/g, ' ').trim();

  // 1. Извлечение серии и номера (4 + 6 цифр)
  const seriesNumberMatch = normalized.match(/\b(\d{4})\s*(\d{6})\b/);
  if (seriesNumberMatch) {
    result.series = seriesNumberMatch[1];
    result.number = seriesNumberMatch[2];
  }

  // 2. Извлечение даты выдачи (формат ДД.ММ.ГГГГ)
  const dateMatch = normalized.match(
    /выдан[а]?\s*(?:\d{2}\.\d{2}\.\d{4})?\s*(\d{2}\.\d{2}\.\d{4})/i
  );

  // Более универсальный вариант, если дата может стоять сразу после слова "выдан"
  const fallbackDateMatch = normalized.match(/(\d{2}\.\d{2}\.\d{4})/);

  if (dateMatch) {
    result.when = dateMatch[1];
  } else if (fallbackDateMatch) {
    result.when = fallbackDateMatch[1];
  }

  // 3. Извлечение "кем выдан"
  // Берём всё, что идёт после даты
  if (result.when) {
    const whomMatch = normalized.match(
      new RegExp(`${result.when}\\s*,?\\s*(.+)$`, 'i')
    );
    if (whomMatch) {
      result.whom = whomMatch[1].trim();
    }
  }

  // Если не удалось извлечь обязательные поля, возвращаем null
  if (!result.series || !result.number) {
    return null;
  }

  return result;
}